<ui-card class="card">
    <div class="app-grid centered container">
        <div class="columns-6">
            <div *ngIf="tagline" class="text-dark tagline">
                <img *ngIf="taglineImgSrc" [attr.src]="taglineImgSrc" />
                <div [ngClass]="{ 'margin-left-1': taglineImgSrc }">{{ tagline | appTranslate }}</div>
            </div>
            <h1 *ngIf="header">{{ header | appTranslate }}</h1>
            <div *ngIf="description" class="text-dark">
                {{ description | appTranslate }}
                <a
                    class="text-dark"
                    (click)="trackLearnMoreEvent()"
                    [routerLink]="['./embed']"
                    [queryParams]="{ moduleName }"
                    >{{ 'add-ons.learnMore' | appTranslate }}</a
                >
            </div>
            <ui-button
                (click)="trackButtonEvent()"
                [routerLink]="['./embed']"
                [queryParams]="{ moduleName }"
                *ngIf="!externalURL"
                class="margin-top-4"
                type="outline"
                >{{ CTAText | appTranslate }}</ui-button
            >
            <ui-button
                externalLink="true"
                [url]="externalURL"
                (click)="trackButtonEvent()"
                *ngIf="externalURL"
                class="margin-top-4"
                type="outline"
                >{{ CTAText | appTranslate }}</ui-button
            >
        </div>

        <div class="columns-6">
            <div *ngIf="src"><img [attr.src]="src" /></div>
        </div>
    </div>
</ui-card>
